import Vue from 'vue'

/**
 * Reflow parent iframe plugin (Drupal specific).
 */
const ReflowIframe = {}

ReflowIframe.install = function () {
  Vue.prototype.$reflowIframe = function () {
    if (typeof window?.parent?.Drupal?.attachBehaviors === 'function') {
      window.parent.Drupal.attachBehaviors()
    }
  }
}

Vue.use(ReflowIframe)
